module.exports = __webpack_public_path__ + "static/media/person3.fc05fd6a.jpg";